module.exports = {"text":{"default":"Type text here"},"error":{"contentSecurityError":"Your session expired or you don't have user permission to edit this video","contentLoadError":"Something went wrong. Please refresh this page to retry or go back to your profile page.","title":"Sorry!","login":"Log in","backToMyWideos":"Back to my wideos","secondaryText-1":"If the problem persists","secondaryText-2":"contact our support team"}}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en/common.json
// module id = 781
// module chunks = 32